const { instance } = require('./url')

async function getAllEquips() {
    return await instance.get('/equip/')
}

async function insertEquip(equip) {
    return await instance.post('/equip/', { equip })
}

async function updateEquip(equip) {
    return await instance.put('/equip/' + equip.id, { equip })
}

async function deleteEquip(id) {
    return await instance.delete('/equip/' + id)
}

module.exports = { getAllEquips, insertEquip, updateEquip, deleteEquip }
